import React from 'react';
import { Printer, X } from 'lucide-react';

const PrintExpense = ({ expense, onClose }) => {
  if (!expense) return null;

  const formatCurrency = (amount) => {
    return new Intl.NumberFormat('en-KE', { style: 'currency', currency: 'KES' }).format(amount || 0);
  };

  const formatDate = (date) => {
    if (!date) return 'N/A';
    return new Date(date).toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' });
  };

  const handlePrint = () => {
    window.print();
  };

  return (
    <div className="print-overlay">
      <div className="print-actions no-print">
        <button onClick={handlePrint} className="btn btn-primary"><Printer size={16} /> Print</button>
        <button onClick={onClose} className="btn btn-secondary"><X size={16} /> Close</button>
      </div>
      
      <div dangerouslySetInnerHTML={{ __html: `
        <html>
        <head>
          <title>Expense Voucher - ${expense._id || 'N/A'}</title>
          <style>
            @page { size: A4; margin: 10mm; }
            body { font-family: 'Segoe UI', Arial, sans-serif; margin: 0; padding: 0; background: #f8fafc; }
            .print-page { max-width: 210mm; margin: 0 auto; background: white; padding: 12mm; box-shadow: 0 4px 20px rgba(0,0,0,0.1); }
            .print-header { display: flex; align-items: center; gap: 12px; border-bottom: 2px solid #1e3a8a; padding-bottom: 8px; margin-bottom: 12px; }
            .print-logo-section img { width: 50px; height: 50px; border-radius: 50%; object-fit: cover; }
            .print-company h1 { font-size: 16px; margin: 0; color: #1e3a8a; }
            .print-company p { font-size: 9px; margin: 1px 0; color: #666; }
            .print-doc-info { text-align: right; margin-left: auto; }
            .print-doc-type { font-size: 18px; font-weight: 700; color: #1e3a8a; text-transform: uppercase; }
            .print-doc-id, .print-doc-date { font-size: 9px; color: #666; }
            .print-section { margin-bottom: 10px; }
            .print-section h3 { font-size: 11px; text-transform: uppercase; color: #1e3a8a; border-bottom: 1px solid #e2e8f0; padding-bottom: 3px; margin-bottom: 6px; margin-top: 0; }
            .print-detail-grid { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; }
            .print-detail-item { display: flex; flex-direction: column; }
            .print-detail-item label { font-size: 8px; text-transform: uppercase; color: #888; margin-bottom: 1px; }
            .print-detail-item span { font-size: 10px; font-weight: 600; color: #333; }
            .print-amount { font-size: 20px; font-weight: 700; color: #1e3a8a; text-align: right; }
            .print-footer { margin-top: 15px; border-top: 1px solid #e2e8f0; padding-top: 8px; font-size: 8px; color: #888; text-align: center; }
            .print-signature { display: flex; justify-content: space-between; margin-top: 25px; }
            .print-signature-box { width: 130px; text-align: center; }
            .print-signature-line { border-top: 1px solid #333; margin-top: 25px; padding-top: 3px; font-size: 9px; }
            @media print { body { background: white; padding: 0; margin: 0; } .print-page { box-shadow: none; width: 100%; padding: 8mm; } .no-print { display: none !important; } }
          </style>
        </head>
        <body>
          <div class="print-page">
            <div class="print-header">
              <div class="print-logo-section">
                <img src="https://www.secs.gismac.co.ke/logos/gismac.jpg" alt="GISMAC Security" />
              </div>
              <div class="print-company">
                <h1>Gismac Security Limited</h1>
                <p>Email: Finance@gismac.co.ke | www.secs.gismac.co.ke</p>
                <p>Nairobi, Kenya</p>
              </div>
              <div class="print-doc-info">
                <div class="print-doc-type">Expense Voucher</div>
                <div class="print-doc-id">Ref: ${expense._id ? expense._id.toString().slice(-8).toUpperCase() : 'N/A'}</div>
                <div class="print-doc-date">${formatDate(expense.expenseDate || expense.createdAt)}</div>
              </div>
            </div>

            <div class="print-section">
              <h3>Expense Details</h3>
              <div class="print-detail-grid">
                <div class="print-detail-item"><label>Category</label><span>${expense.category || 'N/A'}</span></div>
                <div class="print-detail-item"><label>Sub Category</label><span>${expense.subCategory || 'N/A'}</span></div>
                <div class="print-detail-item"><label>Date</label><span>${formatDate(expense.expenseDate || expense.date)}</span></div>
                <div class="print-detail-item"><label>Payment Method</label><span>${expense.paymentMethod || 'N/A'}</span></div>
                <div class="print-detail-item"><label>Vendor / Supplier</label><span>${expense.vendor || expense.supplier || 'N/A'}</span></div>
                <div class="print-detail-item"><label>Status</label><span>${expense.status || 'Pending'}</span></div>
              </div>
            </div>

            <div class="print-section">
              <h3>Amount</h3>
              <div class="print-amount">${formatCurrency(expense.amount || 0)}</div>
            </div>

            ${expense.description ? `<div class="print-section"><h3>Description</h3><p style="font-size: 10px; color: #555; line-height: 1.3; margin: 0;">${expense.description}</p></div>` : ''}

            <div class="print-signature">
              <div class="print-signature-box">
                <div class="print-signature-line">Prepared By</div>
                <div style="font-size: 8px; color: #888; margin-top: 3px;">${expense.createdBy || expense.submittedBy || '_________________'}</div>
              </div>
              <div class="print-signature-box">
                <div class="print-signature-line">Approved By</div>
                <div style="font-size: 8px; color: #888; margin-top: 3px;">Finance Manager</div>
              </div>
              <div class="print-signature-box">
                <div class="print-signature-line">Date</div>
                <div style="font-size: 8px; color: #888; margin-top: 3px;">${formatDate(new Date())}</div>
              </div>
            </div>

            <div class="print-footer">
              <p><strong>Bank:</strong> Equity Bank Kenya | <strong>Account:</strong> Gismac Security Ltd | <strong>Swift:</strong> EQBLKENA</p>
              <p>Payment Terms: Payment due within 30 days. Late payments subject to 1.5% monthly interest.</p>
              <p>Generated by GISMAC Security Management System</p>
            </div>
          </div>
        </body>
        </html>
      `}} />
    </div>
  );
};

export default PrintExpense;
